module.exports = __webpack_public_path__ + "img/alert-circle.51dac6ab.png";